module.exports = {"TXTCLI_The_current_password_you_have__ELL":{"id":"TXTCLI_The_current_password_you_have__ELL","defaultMessage":"Введено неправильний пароль"}}